/**
 * Gorgias Chat Widget Visibility Controller
 * Build-a-Box page only
 * Shows when ATC button shows (tied to .juo-box__checkout-wrapper.show)
 * Mobile only (≤749px), requires PPC UTM source
 */

(function() {
  'use strict';

  const CONFIG = {
    requireUtm: false,     // Set to false to show for ALL traffic (toggle this to enable/disable UTM filtering)
    checkInterval: 100,    // Check every 100ms for widget
    maxChecks: 50,         // Stop checking after 5 seconds (50 * 100ms)
    allowedUtmSources: ['facebook', 'instagram', 'google', 'tiktok', 'pinterest', 'snapchat', 'youtube', 'linkedin', 'twitter'] // PPC UTM sources
  };

  let widgetShown = false;
  let checkCount = 0;
  let widget = null;

  // Get UTM source from URL, sessionStorage, or 30-day cookie (same logic as locked products)
  function getUtmSource() {
    const urlParams = new URLSearchParams(window.location.search);
    const urlUtm = urlParams.get('utm_source') || urlParams.get('tw_source');
    if (urlUtm) return urlUtm;
    
    // Check hash parameters
    const hashParams = new URLSearchParams(window.location.hash.split('?')[1] || '');
    const hashUtm = hashParams.get('utm_source') || hashParams.get('tw_source');
    if (hashUtm) return hashUtm;
    
    // Check sessionStorage (current session)
    const sessionUtm = sessionStorage.getItem('ghf_utm_source');
    if (sessionUtm) return sessionUtm;
    
    // Check 30-day cookie (persists across sessions)
    const value = "; " + document.cookie;
    const parts = value.split("; ghf_utm_source=");
    if (parts.length === 2) {
      return parts.pop().split(";").shift();
    }
    
    return null;
  }

  // Check if current UTM matches allowed sources
  function hasValidUtm() {
    // If UTM not required, always return true (show for all traffic)
    if (!CONFIG.requireUtm) return true;
    
    const utmSource = getUtmSource();
    if (!utmSource) return false;
    
    return CONFIG.allowedUtmSources.some(source => 
      utmSource.toLowerCase().includes(source.toLowerCase())
    );
  }

  // Wait for widget to be injected by Gorgias
  function findWidget() {
    widget = document.querySelector('#gorgias-chat-container');
    
    if (widget) {
      // CSS already hides it, just mark as found
      return true;
    }
    
    checkCount++;
    if (checkCount < CONFIG.maxChecks) {
      setTimeout(findWidget, CONFIG.checkInterval);
    }
    return false;
  }

  // Show widget with smooth transition
  function showWidget() {
    if (!widget) return;
    
    // Only show on mobile (<=749px)
    if (window.innerWidth > 749) return;
    
    // Only show if valid UTM source
    if (!hasValidUtm()) return;
    
    widgetShown = true;
    widget.style.setProperty('opacity', '1', 'important');
    widget.style.setProperty('visibility', 'visible', 'important');
  }
  
  // Hide widget
  function hideWidget() {
    if (!widget) return;
    
    widgetShown = false;
    widget.style.setProperty('opacity', '0', 'important');
    widget.style.setProperty('visibility', 'hidden', 'important');
  }

  // Watch ATC button visibility and position
  function watchAtcButton() {
    const summaryWrapper = document.querySelector('.juo-box__summary-wrapper');
    
    if (!summaryWrapper) {
      console.log('Gorgias: Summary wrapper not found');
      return;
    }
    
    // Check if ATC is at bottom of viewport (not scrolled up)
    function checkPosition() {
      if (!summaryWrapper.classList.contains('show')) {
        hideWidget();
        return;
      }
      
      const rect = summaryWrapper.getBoundingClientRect();
      const distanceFromBottom = window.innerHeight - rect.bottom;
      
      // Show only if ATC is within 10px of bottom (at its fixed position)
      // Hide immediately if it moves up more than 10px
      if (distanceFromBottom >= -10 && distanceFromBottom <= 10) {
        showWidget();
      } else {
        hideWidget();
      }
    }
    
    // Check on scroll
    let scrollTicking = false;
    window.addEventListener('scroll', function() {
      if (!scrollTicking) {
        window.requestAnimationFrame(function() {
          checkPosition();
          scrollTicking = false;
        });
        scrollTicking = true;
      }
    }, { passive: true });
    
    // Watch for .show class changes
    const classObserver = new MutationObserver(function() {
      checkPosition();
    });
    
    classObserver.observe(summaryWrapper, {
      attributes: true,
      attributeFilter: ['class']
    });
    
    // Initial check
    checkPosition();
  }

  // Initialize
  function init() {
    // Start looking for widget
    findWidget();
    
    // Watch ATC button visibility
    watchAtcButton();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
